const BASE_URL = process.env.VUE_APP_HTTP;

export default function clearUrl(value) {
  // FIXME make sure that this work on production
  if (!value) return "";
  // const base = value.replace('https://','');
  // const base2 = base.replace('http://','');
  value = value.replace(BASE_URL, "");

  return value || "/";
}
